module.exports = new __parcel__URL__("marketplace-logo.29038a85.svg").toString();